import Link from "next/link";
import { useRouter } from "next/router";
import { AuthedPage } from "pages/AuthedPage";
import { useEffect } from "react";

export default function IndexPage() {
  const router = useRouter();
  const orgId = router.query.orgId;
  const defaultPageUrl = `/${orgId}/home`;

  useEffect(() => {
    if (orgId) router.replace(defaultPageUrl);
  }, [orgId, router, defaultPageUrl]);

  return (
    <AuthedPage
      orgId
      main={() => (
        <div style={{ padding: 40 }}>
          You should soon be redirected to{" "}
          <Link href={defaultPageUrl}>home</Link>.
        </div>
      )}
    />
  );
}
